/* eslint-disable @typescript-eslint/no-explicit-any */
import ImageOptimize from '@/components/ImageOptimize'
import ModuleBanner from '@/components/LandingPageModule/ModuleBanner'
import ModuleBannerL2 from '@/components/LandingPageModule/ModuleBannerL2'
import ModuleProductList from '@/components/LandingPageModule/ModuleProductList'
import ModuleProductListFull from '@/components/LandingPageModule/ModuleProductListFull'
import ModuleProductTab from '@/components/LandingPageModule/ModuleProductTab'
import ModuleSlider from '@/components/LandingPageModule/ModuleSlider'
import ModuleTabScroll from '@/components/LandingPageModule/ModuleTabScroll'
import ProductCard from '@/components/ProductCard'
import { BLOCK_CMS_TYPE, PageType, ProductCardType, PromotionTypes } from '@/constants'
import { Header } from '@/layouts/Header'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import { type BlockCMS, type Product, type Promotion } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import { getPromotionDetail, getSaleRegion } from '@/utils/endpoint'
import * as pixel from '@/utils/fpixel'
import { getCookies } from 'cookies-next'
import { type GetServerSideProps, type GetServerSidePropsContext } from 'next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const PromotionDetail = ({
  promotionDetail,
}: {
  promotionDetail: Promotion
}) => {
  const router = useRouter()
  useEffect(() => {
    pixel.fbqEvent('ViewContent')
  }, [])

  const renderCMS = (data: BlockCMS, index: number) => {

    switch (data.type) {
      case BLOCK_CMS_TYPE.SLIDER:
        return data && data.data.length > 0 ? (
          <ModuleSlider data={data} key={index} />
        ) : (
          ''
        )
        break
      case BLOCK_CMS_TYPE.BANNER_ONE_LINE:
        return data && data.data.length > 0 ? (
          <ModuleBanner data={data} key={index} />
        ) : (
          ''
        )
        break
      case BLOCK_CMS_TYPE.BANNER_22:
        return data && data.data.length > 0 ? (
          <ModuleBannerL2 data={data} key={index} />
        ) : (
          ''
        )
        break
      case BLOCK_CMS_TYPE.PRODUCT_LIST:
        return data && data.data.length > 0 ? (
          <ModuleProductList data={data} key={index} />
        ) : (
          ''
        )
        break
      case BLOCK_CMS_TYPE.PRODUCT_TAB:
        return data && data.data.length > 0 ? (
          <ModuleProductTab data={data} key={index} />
        ) : (
          ''
        )
        break
      case BLOCK_CMS_TYPE.TAB_SCROLL:
        return data && data.data.length > 0 ? (
          <ModuleTabScroll data={data} key={index} />
        ) : (
          ''
        )
        break
      case BLOCK_CMS_TYPE.PRODUCT_LIST_FULL:
        return data && data.data.length > 0 ? (
          <ModuleProductListFull data={data} key={index} order={index} />
        ) : (
          ''
        )
        break
      default:
        break
    }
  }
  {
    if (promotionDetail && promotionDetail?.type == PromotionTypes.CMS_PAGE) {
      return (
        <Main
          showRecentlyViewed
          bgColor={promotionDetail?.customization?.backgroundColor || '#F3F4F6'}
          pageLayout=''
          dataHeader={getTranslate(promotionDetail?.name)}
          meta={
            <Meta
              title={getTranslate(promotionDetail?.name)}
              description={getTranslate(promotionDetail?.content)}
              canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
            />
          }
          hideMenu
          showFooter
          showKeywords={false}
        >
          <Header
            layout={PageType.PAGE_CMS as string | ''}
            dataHeader={''}
            btnHome={false}
            page={''}
          />
          <div className='page-cms pb-3'>
            {promotionDetail &&
              promotionDetail?.mobilePromotionBlocks?.map((item, index) => {
                return renderCMS(item, index)
              })}
          </div>
        </Main>
      )
    } else {
      return (
        <Main 
          showRecentlyViewed
          meta={
            <Meta
              title={getTranslate(promotionDetail?.name)}
              description={getTranslate(promotionDetail?.content)}
              canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
            />
          }
          dataHeader={getTranslate(promotionDetail?.name)}
          hideMenu
          bgColor={promotionDetail?.customization?.backgroundColor || ''} showFooter showKeywords={false}>
        
          <section className='orderList min-h-[calc(100svh-60px)] pb-[120px]'>
            <div className='promotionBanner'>
              <ImageOptimize
                className='rounded'
                width={640}
                height={300}
                src={
                  promotionDetail?.customization?.banner ||
                  promotionDetail?.mobileBanner ||
                  ''
                }
                alt={getTranslate(promotionDetail?.name)}
                priority
              />
            </div>
            <div className='container pt-3'>
              <div className='listProduct grid grid-cols-2 gap-3'>
                {promotionDetail &&
                  promotionDetail?.products.map(
                    (item: Product, index: number) => {
                      return (
                        <ProductCard
                          product={item}
                          layout={2}
                          type={item.flashSale ? ProductCardType.FLASH_SALE : ProductCardType.PRODUCT_CARD}
                          className=''
                          key={item._id + index + promotionDetail?.type}
                        />
                      )
                    }
                  )}
              </div>
            </div>
          </section>
        </Main>
      )
    }
  }
}

export default PromotionDetail

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, res, query } = context
  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )

  const { slug } = query
  if (!slug) {
    return {
      notFound: true,
    }
  }

  const [promotionDetail, regions] = await Promise.all([
    getPromotionDetail(slug as string),
    getSaleRegion(),
  ])

  if (!promotionDetail) {
    return {
      notFound: true,
    }
  }
  return {
    props: {
      language,
      messages,
      regions,
      promotionDetail,
      token: token || null,
    },
  }
}
